import classNames from 'classnames';
import PropTypes from 'prop-types';

import gcatCodeIconColor from '../utils/gcatCodeIconColor';

import { GcatCodeIcon } from './generic';
import SvgColorImg from './SvgColorImg';

const ParticipantIcon = function ParticipantIcon({
  initials,
  color,
  gcatCode,
  grpGpid,
  grpLbl,
  groupsMap,
  imagesMap,
  invertCcatColors,
  className,
}) {
  // const { profile } = useProfile();
  // const {
  //   selectedRole,
  // } = profile;
  const selectedRole = { staff: true };

  if (gcatCode
      && grpGpid
      && ((gcatCode !== 'users') || (!initials))
  ) {
    const thisGroup = groupsMap.get(grpGpid);

    // console.log(`PhoneParticipantIcon gcatCode=${
    //   gcatCode} grpGpid=${grpGpid} thisGroup=${
    //   !!thisGroup} `);

    const thisGroupLogo = (thisGroup)
      ? imagesMap.get(thisGroup.logoId)
      : null;

    if (thisGroupLogo) {
      return (
        <div className={
          classNames(
            'h-7 w-7 flex flex-row justify-center items-center shrink-0',
            className,
          )
        }
        >
          <img
            className="h-full w-full object-contain"
            alt={grpLbl}
            src={thisGroupLogo}
          />
        </div>
      );
    }
  }

  let thisIconBgColor;
  let ThisGcatCodeIcon;

  const invert = invertCcatColors && ((gcatCode !== 'users') || (!initials));
  const staff = selectedRole?.staff;

  if (!invert) {
    thisIconBgColor = (gcatCode
                      && (gcatCode !== 'users')
                      && (!staff))
      ? gcatCodeIconColor(gcatCode)
      : color;

    ThisGcatCodeIcon = (gcatCode
                        && ((gcatCode !== 'users') || (!initials)))
      ? GcatCodeIcon({
          gcatCode,
          className: 'fill-white',
        })
      : null;
  } else {
    thisIconBgColor = 'white';
    const thisIconColor = (gcatCode
                        && (gcatCode !== 'users')
                        && (!staff))
      ? gcatCodeIconColor(gcatCode)
      : color || gcatCodeIconColor(gcatCode);

    ThisGcatCodeIcon = (gcatCode
                        && ((gcatCode !== 'users') || (!initials)))
      ? GcatCodeIcon({
          gcatCode,
          imgColor: thisIconColor,
        })
      : null;
  }

  if (ThisGcatCodeIcon) {
    return (
      <div
        className={
          classNames(
            'h-6.5 w-6.5 rounded-full flex flex-row justify-center items-center text-center shrink-0 ring-inset ring-1 ring-black/15',
            {
              'p-px': invert,
              'p-0.75': !invert,
            },
            className,
          )
        }
        style={{ backgroundColor: thisIconBgColor }}
      >
        {ThisGcatCodeIcon}
      </div>
    );
  }

  return (
    <div
      className={
        classNames(
          'h-6.5 w-6.5 rounded-full p-0.5 flex flex-row justify-center items-center text-center shrink-0 ring-inset ring-1 ring-black/15',
          className,
        )
      }
      style={{ backgroundColor: thisIconBgColor }}
    >
      <SvgColorImg
        src="/images/svg/gcat/people/user.svg"
        imgColorAsCssFill
        description=""
        className="h-full w-full fill-white"
      />
    </div>
  );
};

ParticipantIcon.propTypes = {
  initials: PropTypes.string,
  color: PropTypes.string,
  gcatCode: PropTypes.string,
  grpGpid: PropTypes.string,
  grpLbl: PropTypes.string,
  groupsMap: PropTypes.instanceOf(Map).isRequired,
  imagesMap: PropTypes.instanceOf(Map).isRequired,
  invertCcatColors: PropTypes.bool,
  className: PropTypes.string,
};

export default ParticipantIcon;
